const routes = [
  {
    path: "/login",
    name: "login",
    component: (_) => import("@/views/login"),
  },
  {
    path: "/home",
    name: "home",
    component: (_) => import("@/views/home/index"),
    props: true,
  },
  {
    path: "/",
    redirect: "home",
    component: (_) => import("@/views/home/index"),
    props: true,
  },
  {
    path: "/about",
    component: (_) => import("@/views/home/about/index"),
  },
  {
    path: "/relation",
    component: (_) => import("@/views/home/relation/index"),
  },
  {
    path: "/suggest",
    component: (_) => import("@/views/home/suggest/index"),
  },
  {
    path: "/search",
    component: (_) => import("@/views/home/search/index"),
  },
  {
    path: "/h5Index",
    component: (_) => import("@/views/h5/index"),
  },
  {
    path: "/h5Detail",
    component: (_) => import("@/views/h5/detail"),
  },
];
export { routes };
